import { React, useState, useEffect, useContext } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Row, Col, Tooltip, Form, Switch, Spin, Checkbox } from 'antd';
import Box from '@iso/components/utility/box';
import { Link } from 'react-router-dom';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import { SelectOption } from '@iso/components/uielements/select';
import { useLocation, useNavigate } from 'react-router-dom';
import ContentHolder from '@iso/components/utility/contentHolder';
import Input from '@iso/containers/Deployments/ApplicationBasicDetails.styles';
// import Input, {
//     InputSearch,
//     InputGroup,
//     Textarea,
// } from '@iso/components/uielements/input';
import api from '../../../api';
import { AppContext } from '../../../context/ContextProvider';
import { AlertContext } from '../../../context/alertContext';
import awsLogo from '../../../assets/images/aws.svg';
import customScriptIcon from '@iso/assets/images/custom-script-icon.svg';
import secretDetectionIcon from '@iso/assets/images/secret-detection-icon.svg';
import sonarcubeIcon from '@iso/assets/images/sonarcube-icon.svg';
import checkmarkIcon from '@iso/assets/images/checkmark-icon.svg';
import { customFilterOption, customSortOptions, formatErrors, marketplaceStatuses, timeSince } from '../../../context/helper';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { StickerWidgetWrapper } from '../../Widgets/SmallCards/SmallCards.styles';
import noDataPlusIcon from '@iso/assets/images/nodata-plus-icon.svg';
import noDataImg from '@iso/assets/images/no-data-found.svg';
import deleteIcon from '@iso/assets/images/tagsDelete.svg';
import plusIcon from '@iso/assets/images/plusIcon.svg';
import Select from '@iso/containers/Deployments/Deployment.styles';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import { fetchBranches } from '../../../apis/Integrations';


const Option = SelectOption;

let divContainerStyle = {
    display: "flex",
    width: "75%",
    justifyContent: "space-between",
    marginTop: "40px"
}

let boxStyle = {
    border: "transparent",
    width: "fit-content",
    padding: "0",
    margin: "0",
}
let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontSize: "16px",
    fontWeight: "500",
    marginBottom: "1px",
};

let innerSubtitleStyle = {
    fontSize: "14px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontType: "regular",
    fontWeight: "400",
    lineHeight: "14px"
}

let boxTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "20px",
    marginBottom: "1px",
};

let boxSubtitleStyle = {
    fontSize: "12px",
    lineHeight: "20px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

let inputStyle = {
    padding: '4px 11px',
    color: 'rgba(0, 0, 0, 0.88)',
    fontSize: '14px',
    borderRadius: '6px',
    height: "40px"
}

const widgetStyle = {
    margin: "20px",
    width: "100%",
};

export default ({
    workflowNodeData,
    workflowEdgesData,
    columnId,
}) => {

    const { openRightDrawer, setOpenRightDrawer, workflowData, setWorkflowData, currentWorkflowData, setCurrentWorkflowData } = useContext(AppContext);
    const { alertOptions, set_alertOptions } = useContext(AlertContext);

    const navigate = useNavigate();
    // const location = useLocation();

    const [form] = Form.useForm();
    // const repoUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:github\.com|gitlab\.com)\/([^/\s]+)\/([^/\s]+)/i;
    const repoUrlRegex = /(?:https?:\/\/)?(?:www\.)?(?:github\.com|gitlab\.com|\@bitbucket\.org)?\/([^/\s]+)\/([^/\s]+)/i;

    const [pushData, setPushData] = useState({
        tag: "",
    });
    

    useEffect(() => {
        console.log("currentWorkflowData in pushClickRightDrawer :", currentWorkflowData);

        let tempData = {
            tag: currentWorkflowData?.pushConfig?.config?.image_tag ? currentWorkflowData.pushConfig?.config?.image_tag : "",
        }

        setPushData({...tempData});

        form.setFieldsValue({
            tag: currentWorkflowData?.pushConfig?.config?.image_tag ? currentWorkflowData.pushConfig?.config?.image_tag : "",
        });
    }, []);

    // useEffect(() => {
    //     let containers = [];
    //     setFetching(true);
    //     api.get(process.env.REACT_APP_API_URI + `/api/project_env/container-registries/?account_id=${currentWorkflowData?.accountId}`).then((res) => {
    //         let data = res.data;
    //         if (data.status) {
    //             let tempData = {};

    //             data.data.map((child, ind) => {
    //                 containers.push(
    //                     <Option key={child.alias + ind + '!'} name="containerRegistry" data-registryId={child.id} data-region={child.region} data-accountId={child.account_id} data-alias={child.alias} data-integrationType={child.integration_type} data-logo={child.container_registry_logo} value={!child.account_id ? `${child.alias}` : `${child.account_id}${child.alias && `(${child.alias})`} / ${child.region}`}>
    //                         <div style={{ width: "100%", display: "flex", justifyContent: "start", alignItems: "center", paddingTop: "0px" }}>
    //                             <img src={child.integration_logo} style={{ width: "15px", height: "15px", marginRight: "10px", alignSelf: "center" }} />
    //                             <p> {!child.account_id ? `${child.alias}` : `${child.account_id}${child.alias && `(${child.alias})`} / ${child.region}`} </p>
    //                         </div>
    //                     </Option>
    //                 );

    //                 if (child.id === currentWorkflowData.pushConfig?.config?.container_registry_id) {
    //                     console.log("entered matched");
    //                     tempData = {
    //                         ...pushData,
    //                         logo: child.integration_logo
    //                     }
    //                 }
    //             });

    //             // setPushData({...tempData});
    //             setContainerRegistryList(containers);
    //             setFetching(false);
    //         }
    //         else {
    //             console.log("error");
    //             setFetching(false);
    //         }
    //     }).catch((err) => {
    //         setFetching(false);
    //         console.log("Error");
    //     });
    // }, []);

    const handelCancel = () => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                data: "",
            },
        });
    }

    const handelInputChange = (e) => {
        console.log("inside handelInputChange event :", e);
        let name = e.target.name;
        let value = e.target.value;

        if (['cpu', 'ram'].includes(name)) {
            setPushData({ ...pushData, [name]: value });
        }
        else {
            setPushData({ ...pushData, [name]: value });
        }
    }

    // const handleSelectChanges = (value, event) => {
    //     // integration-redirect
    //     console.log("inside handleSelectChanges event :", event);
    //     console.log("inside handleSelectChanges value :", value);
    //     if (event.name === "containerRegistry") {
    //         setPushData({
    //             ...pushData,
    //             [event.name]: value,
    //             containerRegistryId: event["data-registryId"],
    //             region: event["data-region"],
    //             accountId: event["data-accountId"],
    //             alias: event["data-alias"],
    //             integrationType: event["data-integrationType"],
    //             logo: event["data-logo"],
    //         });
    //     }
    //     // else if (event.name === "appSource" && event["data-key"]) {
    //     //     setPushData({ ...pushData, [event.name]: event.type, dockerRepoUrl: "", repoUrl: "", accountId: event["data-key"], accountName: event["data-alias"], isPrivate: false });
    //     // }
    //     // else if ((event.name === "appSource") && (event.type === "public")) {
    //     //     setPushData({ ...pushData, [event.name]: event.type, dockerRepoUrl: "", repoUrl: "", dockerFilePath: "", accountId: "", accountName: "", branch: "", isPrivate: false });
    //     //     return;
    //     // }
    //     // else if (event.name === "dockerRepoUrl") {
    //     //     console.log('event["data-url"] :', event["data-url"]);
    //     //     console.log('event["data-isprivate"] :', event["data-isprivate"]);
    //     //     setPushData({ ...pushData, [event.name]: event.type, repoUrl: event["data-url"], isPrivate: event["data-isprivate"], isOwner: event["is-owner"] });
    //     // }
    //     // else if (event.type === "integration") {
    //     //     handleCancel();
    //     //     navigate("/integrations");
    //     //     return;
    //     // }
    //     else {
    //         setPushData({ ...pushData, [event.name]: event.value });
    //     }
    // }

    const handleSaveDetails = async (e) => {
        console.log("clicked handleSaveDetails...",);
        handelCancel();

        // try {
        //     const values = await form.validateFields();
        //     console.log('Success:', values);

        //     currentWorkflowData.pushConfig.config = {
        //         ...currentWorkflowData.pushConfig.config,
        //         region: pushData.region,
        //         docker_repo_name: pushData.containerRegistry,
        //         container_registry_id: pushData.containerRegistryId,
        //         dockerfile: pushData.dockerfilePath,
        //         account_id: pushData.accountId,
        //         alias: pushData.alias,
        //         integration_type: pushData.integrationType,
        //         build_context: pushData.buildContext,
        //         container_registry_logo: pushData.logo,
        //         platform: pushData.platform,
        //         cpu: pushData.cpu,
        //         ram: pushData.ram,
        //         volume: pushData.volume,
        //         spot: pushData.spot,
        //         cacheEnabled: pushData.cacheEnabled,
        //     };

        //     setCurrentWorkflowData({ ...currentWorkflowData });
        //     localStorage.setItem("Workflow", JSON.stringify({ ...currentWorkflowData }));
        //     handelCancel();
        // }
        // catch (err) {
        //     console.log("Found error :", err);
        // }

    }

    const handleCancel = (e) => {
        console.log("clicked handleCancel...");
        handelCancel();
    }

    // const filterReposOption = (input, option) => {
    //     if (option.key) {
    //         return (option?.props?.type?.toLowerCase() ?? '').includes(input?.toLowerCase())
    //     }
    // };

    // const filterOption = (input, option) => {
    //     if (option.key) {
    //         return (option?.props.value.toLowerCase() ?? '').includes(input?.toLowerCase())
    //     }
    // };


    return (
        <LayoutWrapper className="clusterInfo" style={{ padding: "0" }}>
            <CreateTaskHeader buttonContent={columnId} onCancel={handelCancel} />

            <div style={{ marginTop: "84px", width: "100%" }} />

            <StickerWidgetWrapper className="isoStickerWidget" style={{ ...widgetStyle, marginTop: "28px" }}>
                <Form
                    form={form}
                    initialValues={{ ...pushData }}
                    preserve={false}
                    name="dynamic_rule"
                    style={{
                        width: "100%",
                    }}
                >

                    <Box
                        title={"Tag*"}
                        subtitle={"Please type you container tag."}
                        titleStyle={boxTitleStyle}
                        subTitleStyle={boxSubtitleStyle}
                        style={{ width: "100%", marginTop: "0", border: "0", padding: "0", height: "fit-content" }}
                    >
                        <ContentHolder style={{ width: "100%", marginTop: "6px" }}>
                            <Form.Item
                                name="tag"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please provide tag.',
                                    }
                                ]}
                            >
                                <div style={{ height: "44px" }}>
                                    <Input className="adjust-height" placeholder="Tag" style={{ height: "44px" }} value={pushData?.tag} disabled={currentWorkflowData?.fromPipeline} name="tag" onChange={handelInputChange} />
                                </div>
                            </Form.Item>
                        </ContentHolder>
                    </Box>

                </Form>
            </StickerWidgetWrapper>

            {!currentWorkflowData?.fromPipeline && <CreateTaskFooter buttonContent={"Source Config"} givenButtonFunction1={handleSaveDetails} givenButtonFunction2={handleCancel} />}
        </LayoutWrapper>
    );
};